import React from "react";

const CheckCircleInfoSmall = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" role="img" aria-hidden="true">
      <g transform="translate(-529 -158)">
        <circle cx="7" cy="7" r="7" fill="#58a225" transform="translate(529 158)" />
        <g>
          <path
            fill="#fff"
            d="M23.5 17l-5 5-3.5-3.5 1.5-1.5 2 2 3.5-3.5 1.5 1.5"
            transform="translate(517 146.5)"
          />
          <path fill="none" d="M0 0H10V10H0z" transform="translate(531 160)" />
        </g>
      </g>
    </svg>
  );
};

export default CheckCircleInfoSmall;
